let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Z2q8")).then(() => parcelRequire('ka71P'));